import { CONFIRMATION_ASSET_FOLDER } from 'constants/Confirmation';
import Link from 'next/link';

import ImageWithFallback from 'components/ImageWithFallback';
import styles from './ConfirmationLinks.module.css';

const LINKS = [
  {
    href: '/about-us',
    label: (
      <>
        About <br /> Us
      </>
    ),
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/about-us.png`,
  },
  {
    href: '/winners',
    label: (
      <>
        Our <br /> Winners
      </>
    ),
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/our-winners.png`,
  },
  {
    href: '/giving-back',
    label: (
      <>
        Our <br /> Impact
      </>
    ),
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/our-impact.png`,
  },
  {
    href: 'https://daymade.zendesk.com/hc/en-gb',
    label: <>FAQ's</>,
    imageSrc: `${CONFIRMATION_ASSET_FOLDER}/faqs.png`,
    openInNewTab: true,
  },
];

export const ConfirmationLinks = () => {
  return (
    <div className={styles.confirmationLinksContainer}>
      {LINKS.map((link) => (
        <Link
          key={link.href}
          href={link.href}
          className={styles.confirmationLink}
          target={link.openInNewTab ? '_blank' : '_self'}
          rel={link.openInNewTab ? 'noopener noreferrer' : undefined}>

          <span className={styles.linkImageWrapper}>
            <ImageWithFallback
              src={link.imageSrc}
              layout="fill"
              objectFit="cover"
            />
            <span className={styles.linkImageOverlay} />
          </span>
          <span className={styles.linkLabelArrowContainer}>
            <span
              className={`${styles.linkLabel} aboutUsTypographyHeaderXlarge`}
            >
              {link.label}
            </span>
            <span className={styles.linkArrowWrapper}>
              <ImageWithFallback
                src={`${CONFIRMATION_ASSET_FOLDER}/arrow.svg`}
                layout="fill"
                objectFit="contain"
                alt="arrow"
              />
            </span>
          </span>

        </Link>
      ))}
    </div>
  );
};
